(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjects', TabObjects)
        .factory('TabObjectsRedeploy', TabObjectsRedeploy)
        .factory('TabObjectsRedeployablesCounter', TabObjectsRedeployablesCounter)
        .factory('TabObjectsMaint', TabObjectsMaint)
        .factory('TabObjectProperties', TabObjectProperties)
        .factory('TabOverrideProperties', TabOverrideProperties);

    TabObjects.$inject = ['$resource'];

    function TabObjects($resource) {
        var resourceUrl = 'api/tab-objects/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.objectAddata = angular.fromJson(data.objectAddata);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'updateMetadata': {method: 'PUT', url: 'api/tab-objects-metadata'},
            'updateMute': {method: 'PUT', url: 'api/tab-objects-mute'},
            'byActions': {
                method: 'POST',
                isArray: true,
                url: 'api/tab-objects/by-actions'
            },
            'byUniqueCode': {
                method: 'GET',
                url: 'api/tab-objects-unique-code/:uniqueCode'
            },
            'viewLastData': {
                method: 'GET',
                url: 'api/view-last-data/:id'
            },
            'timeZones': {
                method: 'GET',
                url: 'api/tab-objects-timezones',
                isArray: true
            },
            'byFleet': {
                method: 'GET',
                url: 'api/tab-objects/by-fleet/:id'
            },
            'simStatus': {method: 'PUT', url: 'api/tab-objects-sim'},
            'byQueue': {
                method: 'GET',
                url: 'api/tab-objects/by-queue',
                isArray: true
            },
            'rerunning':{
                method: 'PUT',
                url: 'api/tab-objects/rerun'
            }
        });
    }

    TabObjectsRedeployablesCounter.$inject = ['$interval', 'TabObjectsRedeploy'];

    function TabObjectsRedeployablesCounter($interval, TabObjectsRedeploy) {
        var stopCalculation = null;
        var numObjs = 2;
        var calc = function calculate() {

            stopCalculation = $interval(function () {
                TabObjectsRedeploy.numOfOnlineAndUntrackedTabObjs({}, {},
                    function (data) {
                        numObjs = data.num;
                    }, function onError(error) {
                        AlertService.error(error.data.message);
                    }
                );
            }, 5000);
        };

        return {
            start: calc,
            stop: function () {
                $interval.cancel(stopCalculation);
            },
            getNumObjs: function () {
                return numObjs;
            }
        };
    }

    TabObjectsRedeploy.$inject = ['$resource'];

    function TabObjectsRedeploy($resource) {
        var resourceUrl = 'api/tab-objects/redeploy/:id';

        return $resource(resourceUrl, {}, {
            'redeploy': {method: 'PUT'},
            'provision': {
                url: 'api/tab-objects/provision/:id',
                method: 'PUT'},
            'redeployAll': {url: 'api/tab-objects/redeploy-all/', method: 'PUT'},
            'numOfOnlineAndUntrackedTabObjs': {
                url: 'api/tab-objects/num-online-untracked-tab-objs',
                method: 'GET',
                isArray: false,
                transformResponse: function (data) {
                    return {'num': data};
                }
            }
        });
    }


    TabObjectsMaint.$inject = ['$resource'];

    function TabObjectsMaint($resource) {
        var resourceUrl = 'api/tab-objects/maint/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }

    TabObjectProperties.$inject = ['$resource'];

    function TabObjectProperties($resource) {
        var resourceUrl = 'api/tab-devices-releases-properties/:id';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'queryByType': {url: "api/tab-devices-releases-properties/object-type/:id", method: 'GET', isArray: true},
            'queryById': {url: "api/tab-devices-releases-properties-by-id/:id", method: 'GET'},
            'occurrence': {url: "api/tab-devices-releases-properties/occurrence", method: 'POST'},
            'elastic': {url: 'api/tab-elastic-properties/:id', method: 'GET'},
            'elasticUpdate': {url: 'api/tab-elastic-update-properties', method: 'PUT'},
            'update': {method: 'PUT', isArray: true}
        });
    }

    TabOverrideProperties.$inject = ['$resource'];

    function TabOverrideProperties($resource) {
        var resourceUrl = 'api/tab-override-properties-by-property/:id';
        return $resource(resourceUrl, {}, {
            'query': {url: 'api/tab-override-properties-by-object', method: 'GET', isArray: true}
        });
    }

})();
